import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function TwoUsers({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <TwoUsers.Outline {...props} />
  ) : (
    <TwoUsers.Solid {...props} />
  );
}

TwoUsers.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <g id="2 User">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.99293 13.1719C11.0671 13.1719 13.6946 13.6377 13.6946 15.4985C13.6946 17.3594 11.0846 17.8385 7.99293 17.8385C4.91793 17.8385 2.29126 17.3769 2.29126 15.5152C2.29126 13.6535 4.90043 13.1719 7.99293 13.1719Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.99295 10.5163C5.97462 10.5163 4.33795 8.88051 4.33795 6.86217C4.33795 4.84384 5.97462 3.20801 7.99295 3.20801C10.0105 3.20801 11.6471 4.84384 11.6471 6.86217C11.6546 8.87301 10.0296 10.5088 8.01878 10.5163H7.99295Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.7359 9.56741C15.0701 9.37991 16.0976 8.23491 16.1001 6.84908C16.1001 5.48324 15.1043 4.34991 13.7984 4.13574"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.4962 12.7764C16.7887 12.9689 17.6912 13.4222 17.6912 14.3555C17.6912 14.998 17.2662 15.4147 16.5795 15.6755"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  });

  return (
    <Icon
      w="element.xl"
      h="6
  "
      {...validateKeys(props)}
    />
  );
};

TwoUsers.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For solid icons, be sure to add `className="icon-primary"`
         * and `className="icon-secondary"` to show the two-tone
         * aspect of the icon if necessary.
         */}
      </>
    ),
  });

  return (
    <Icon
      w="element.xl"
      h="6
  "
      {...validateKeys(props)}
    />
  );
};
